// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

const views = require.context('.', true, /\.js$/)
views.keys().forEach(views)
